<template>
    <section class="creditor section-space">
        <div class="pbb-container creditor__layout">
            <div>
                <span class="eyebrow">Jornada do credor</span>
                <h2 class="section-title">Tudo o que você precisa, em poucos passos.</h2>
                <p class="section-intro">
                    Organizamos as principais ações por objetivo para reduzir dúvidas e facilitar o
                    acompanhamento de cada processo.
                </p>
                <v-btn class="pbb-btn mt-8" color="secondary" depressed @click="openAccess"
                    >Entrar na área do credor
                    <v-icon right size="18">mdi-lock-outline</v-icon></v-btn
                >
            </div>
            <div class="creditor__steps">
                <router-link
                    v-for="(item, index) in items"
                    :key="item.route"
                    :to="item.route"
                    class="creditor__step pbb-focus"
                >
                    <span class="creditor__number">0{{ index + 1 }}</span
                    ><span class="creditor__icon"
                        ><v-icon size="25">{{ item.icon }}</v-icon></span
                    >
                    <span class="creditor__text"
                        ><strong>{{ item.title }}</strong
                        ><small>{{ item.description }}</small></span
                    ><v-icon color="secondary">mdi-arrow-top-right</v-icon>
                </router-link>
            </div>
        </div>
    </section>
</template>
<script>
import { eventHub } from '@/main';
export default {
    name: 'CreditorAccessSection',
    data: () => ({
        items: [
            {
                icon: 'mdi-briefcase-search-outline',
                title: 'Localize seu processo',
                description: 'Consulte a empresa, o número e a situação processual.',
                route: '/recuperacao-judicial'
            },
            {
                icon: 'mdi-file-upload-outline',
                title: 'Envie sua habilitação',
                description: 'Protocole habilitações ou divergências de crédito.',
                route: '/habilitacoes-divergencias'
            },
            {
                icon: 'mdi-folder-open-outline',
                title: 'Acompanhe os documentos',
                description: 'Acesse decisões, editais, atas e relatórios publicados.',
                route: '/central-documento'
            },
            {
                icon: 'mdi-calendar-check-outline',
                title: 'Participe da assembleia',
                description: 'Confira datas e realize o credenciamento para a AGC.',
                route: '/assembleia-credores'
            }
        ]
    }),
    methods: {
        openAccess() {
            eventHub.$emit('DIALOG-ACCESS-FORM', true);
        }
    }
};
</script>
<style scoped lang="scss">
.creditor {
    overflow: hidden;
    background: var(--pbb-navy);
    color: #fff;
}
.creditor__layout {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 100px;
    align-items: center;
}
.creditor .section-title {
    color: #fff;
}
.creditor .section-intro {
    color: rgba(255, 255, 255, 0.64);
}
.creditor__steps {
    border-top: 1px solid rgba(255, 255, 255, 0.14);
}
.creditor__step {
    display: grid;
    grid-template-columns: 38px 48px 1fr auto;
    gap: 18px;
    align-items: center;
    padding: 25px 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
    color: #fff;
    text-decoration: none;
    transition: 180ms ease;
}
.creditor__step:hover {
    padding-right: 16px;
    padding-left: 16px;
    background: rgba(255, 255, 255, 0.045);
}
.creditor__number {
    color: rgba(255, 255, 255, 0.35);
    font-size: 11px;
}
.creditor__icon {
    display: grid;
    width: 46px;
    height: 46px;
    place-items: center;
    border-radius: 8px;
    background: rgba(201, 132, 80, 0.15);
}
.creditor__icon .v-icon {
    color: #e1a575;
}
.creditor__text strong,
.creditor__text small {
    display: block;
}
.creditor__text strong {
    font-size: 16px;
}
.creditor__text small {
    margin-top: 5px;
    color: rgba(255, 255, 255, 0.54);
    font-size: 12px;
}
@media (max-width: 900px) {
    .creditor__layout {
        grid-template-columns: 1fr;
        gap: 60px;
    }
}
@media (max-width: 560px) {
    .creditor__step {
        grid-template-columns: 42px 1fr auto;
    }
    .creditor__number {
        display: none;
    }
}
</style>
